import React, { forwardRef, useEffect, useState } from 'react'
import {
  Input,
  NumberInput,
  Radio,
  Menu,
  Checkbox,
  Tooltip,
  Select,
} from '@mantine/core'
import styled from '@emotion/styled'
import { toString } from 'lodash-es'
import { IconMaps } from '@ow/icons'
import CheckComp from '../components/Check'
import TitleComp from '../components/Title'
import DragGroup from '../components/dragGroup'
import ErrorTip from '../components/errorTip'
import BasicSettings from '../components/BasicSettings'
import SelectsDetail from './selectsDetail'
// 参数Controller, control, register
const HandleOptioner = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  > div:first-child {
    width: 80%;
  }
  > div:last-child {
    width: 20%;
  }
  .mantine-Checkbox-body,
  .mantine-Radio-body {
    width: 100%;
    align-items: center;
  }
  .mantine-Radio-inner {
    align-self: center;
  }
  .mantine-Checkbox-labelWrapper,
  .mantine-Radio-labelWrapper {
    flex: 1;
  }
  .item-handle {
    display: flex;
    align-items: center;
    transition: visibility 0.3s, opacity 0.3s;
    visibility: hidden;
    opacity: 0;
  }
  &:hover {
    .item-handle {
      visibility: visible;
      opacity: 1;
    }
  }

  .check-needinput {
    margin: 0 4px;
    cursor: pointer;
  }

  .add-item {
    cursor: pointer;
    border-radius: 2px;
    margin: 0 4px;
    &:hover {
      background-color: #f3f3f3;
    }
  }
  .delete-item {
    cursor: pointer;
    border-radius: 2px;
    position: relative;
    height: 20px;
    width: 20px;
    .delete-acitive {
      position: absolute;
      transition: visibility 0.3s, opacity 0.3s;
      visibility: hidden;
      opacity: 0;
    }
    .delete-normal {
      position: absolute;
      transition: visibility 0.3s, opacity 0.3s;
      visibility: visible;
      opacity: 1;
    }
    &:hover {
      background-color: #fdecee;
      .delete-acitive {
        visibility: visible;
        opacity: 1;
      }
      .delete-normal {
        visibility: hidden;
        opacity: 0;
      }
    }
  }
`

const OptionContainer = styled.div`
  // color: red;
  display: flex;
  width: 100%;
  position: relative;

  .tip-position {
    position: absolute;
    left: -32px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    z-index: 1;
  }

  .operate-contain {
    display: flex;
    width: 100%;
    left: -32px;
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .acitve-item {
    background-color: #ecf2fe;
  }
`

const COLORLIST = [
  { title: '蓝色', color: '#0152D9' },
  { title: '红色', color: '#E34D59' },
  { title: '橙色', color: '#ED7B2F' },
  { title: '绿色', color: '#00A870' },
  { title: '灰色', color: '#C5C5C5' },
  { title: '深灰色', color: '#7787A2' },
  { title: '黄色', color: '#EDB304' },
  { title: '洋红色', color: '#ED4AB4' },
  { title: '青色', color: '#2BCFE7' },
]
/**
 * 列表排序
 * @param {array} list 排序的列表
 * @param {number} startIndex 排序前的索引
 * @param {number} endIndex 排序后的索引
 * @returns
 */
const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}
/**
 * 取 m-n 之间的随机整数
 * @returns {boolean} 是否存在选项
 */
const rand = (m, n) => {
  return Math.floor((n + 1 - m) * Math.random() + m)
}

/**
 * 创建一个新 option 选项
 * @returns {boolean} 是否存在选项
 */
const getNewOption = (optionList) => {
  const random = Math.round(Math.random() * 100)
  let newOption = {
    slug: `option${random}`,
    color: `${COLORLIST[rand(0, 8)].color}`,
    intro: '',
    score: 0,
    title: `选项`,
    value: `option${random}`,
    checked: false,
    needInput: false,
    inputValue: '',
  }
  if (optionList.find((e) => e.slug === newOption.slug)) {
    newOption = getNewOption(optionList)
  }
  return newOption
}

const OptionItem = ({ item, index, onColorChange, onTitleChange }) => {
  return (
    <OptionContainer>
      <Tooltip
        wrapLines
        width={120}
        withArrow
        transition="fade"
        transitionDuration={200}
        label="设置为默认选中"
        classNames={{ root: 'tool-tip-root' }}
      >
        <div className="tip-position" />
      </Tooltip>

      <div
        className="operate-contain"
        onClick={(e) => {
          e.preventDefault()
        }}
      >
        <div className="flex justify-start items-center w-full">
          <Menu width={200}>
            <Menu.Target>
              <div className="w-4 h-4 rounded-lg mr-2 cursor-pointer flex justify-center items-center hover:bg-gray-200">
                <div
                  className="w-2 h-2 rounded-lg"
                  style={{ backgroundColor: item.color }}
                />
              </div>
            </Menu.Target>
            <Menu.Dropdown>
              {COLORLIST.map((colorItem, i) => (
                <Menu.Item
                  key={colorItem.color}
                  type={null}
                  className={`item ${
                    colorItem.color === item.color ? 'acitve-item' : ''
                  }`}
                  component="div"
                  onClick={() => {
                    onColorChange(colorItem, i)
                  }}
                >
                  <div className="flex justify-start items-center">
                    <div
                      className="w-2 h-2 rounded-lg mx-2"
                      style={{
                        backgroundColor:
                          colorItem.color || COLORLIST[index].color,
                      }}
                    />
                    <span>{colorItem.title}</span>
                  </div>
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
          <Input
            value={item.title}
            style={{ width: '100%' }}
            onChange={(e) => {
              onTitleChange(e.target.value)
            }}
          />
        </div>
      </div>
    </OptionContainer>
  )
}
const otherSelectsList = [
  { label: '文本', value: 'text' },
  { label: '数字', value: 'number' },
]
const HandleOption = ({
  item,
  index,
  getValues,
  reset,
  onDelete,
  onAddItem,
}) => {
  const [isSelected, setIsSelected] = useState(false)
  const [inputType, setInputType] = useState(otherSelectsList[0].value)
  useEffect(() => {
    setIsSelected(item.needInput)
    setInputType(item.inputType)
  }, [item])
  return (
    <div className="item-handle">
      <Tooltip
        wrapLines
        withArrow
        transition="fade"
        transitionDuration={200}
        label="是否允许用户针对该选项输入其他内容"
      >
        <div className="flex items-center">
          <Checkbox
            className="check-needinput"
            styles={{ input: { cursor: 'pointer' } }}
            key={item.slug}
            value={item.slug}
            checked={item.needInput}
            onChange={(e) => {
              const { checked } = e.target
              const newList = getValues('selects')
              newList[index].needInput = checked
              setIsSelected(checked)
              if (checked) {
                newList[index].inputType = 'text'
              }
              reset({ ...getValues(), selects: newList })
            }}
          />
          {isSelected && (
            <Select
              style={{ width: '100px' }}
              data={otherSelectsList}
              value={inputType}
              onChange={(val) => {
                const newList = getValues('selects')
                newList[index].inputType = val
                reset({ ...getValues(), selects: newList })
              }}
            />
          )}
        </div>
      </Tooltip>
      <div
        onClick={() => {
          onAddItem()
        }}
        className="add-item"
      >
        <IconMaps type="add" fill="#181818" width={20} height={20} />
      </div>
      <div
        onClick={() => {
          onDelete()
        }}
        className="delete-item"
      >
        <div className="delete-normal">
          <IconMaps
            type="redDeleteIcon"
            fill="#181818"
            width={20}
            height={20}
            size={20}
          />
        </div>

        <div className="delete-acitive">
          <IconMaps type="redDeleteIcon" width={20} height={20} size={20} />
        </div>
      </div>
    </div>
  )
}

const SelectsComp = ({
  watch,
  reset,
  // register,
  getValues,
  control,
  Controller,
}) => {
  const [errorTip, setErrorTip] = useState()
  return (
    <>
      {getValues('multiple') ? (
        <Controller
          name="selects"
          control={control}
          render={({ field }) => {
            const { value, ...otherFieldProp } = field
            return (
              <DragGroup
                {...otherFieldProp}
                list={watch('selects') || []}
                keyProp="slug"
                groupType="checkbox"
                value={getValues('defaultChecked')}
                styles={{
                  label: { color: 'var(--ow-color-gray-100)', width: '100%' },
                  root: { width: '100%' },
                }}
                onDragEnd={(result) => {
                  if (!result.destination) {
                    return
                  }
                  const newList = reorderList(
                    getValues('selects'),
                    result.source.index,
                    result.destination.index
                  )
                  reset({ ...getValues(), selects: newList })
                }}
                onChange={(options) => {
                  if (
                    getValues('rangeSetting') &&
                    (options.length < getValues('minlen') ||
                      getValues('maxlen') < options.length)
                  ) {
                    setErrorTip('超过限定可选项数了')
                    let timeId = null
                    timeId = setTimeout(() => {
                      setErrorTip(false)
                      clearTimeout(timeId)
                    }, 3000)
                    return
                  }
                  const newList = getValues('selects')
                  newList.forEach((e) => {
                    e.checked = options.includes(e.slug)
                  })
                  reset({
                    ...getValues(),
                    selects: newList,
                    defaultChecked: options,
                  })
                }}
              >
                {watch('selects', []).map((e, i) => (
                  <HandleOptioner key={`container-${e.slug}-i`}>
                    <Checkbox
                      key={e.slug}
                      value={e.slug}
                      checked={e.checked}
                      label={
                        <OptionItem
                          item={e}
                          index={i}
                          onColorChange={(item) => {
                            const newList = getValues('selects')
                            newList[i].color = item.color
                            reset({ ...getValues(), selects: newList })
                          }}
                          onTitleChange={(val) => {
                            const newList = getValues('selects')
                            newList[i].title = val
                            reset({ ...getValues(), selects: newList })
                          }}
                        />
                      }
                    />
                    <HandleOption
                      item={e}
                      index={i}
                      getValues={getValues}
                      reset={reset}
                      watch={watch}
                      onDelete={() => {
                        const newList = getValues('selects')
                        newList.splice(i, 1)
                        reset({ ...getValues(), selects: newList })
                      }}
                      onAddItem={() => {
                        const newList = getValues('selects')
                        newList.splice(i + 1, 0, getNewOption(newList))
                        reset({ ...getValues(), selects: newList })
                      }}
                    />
                  </HandleOptioner>
                ))}
              </DragGroup>
            )
          }}
        />
      ) : (
        <Controller
          name="selects"
          control={control}
          render={({ field }) => {
            const { value, ...otherFieldProp } = field
            // field.value = toString(field.value)
            return (
              <DragGroup
                {...otherFieldProp}
                list={watch('selects', [])}
                keyProp="slug"
                value={
                  (getValues('defaultChecked') &&
                    getValues('defaultChecked')[0]) ||
                  ''
                }
                styles={{
                  label: { color: 'var(--ow-color-gray-100)' },
                }}
                onDragEnd={(result) => {
                  if (!result.destination) {
                    return
                  }
                  const newList = reorderList(
                    getValues('selects'),
                    result.source.index,
                    result.destination.index
                  )
                  reset({ ...getValues(), selects: newList })
                }}
                onChange={(option) => {
                  const newList = getValues('selects')
                  if (option) {
                    const changeIndex = newList.findIndex(
                      (e) => e.value === option
                    )
                    newList.forEach((e, i) => {
                      e.checked = changeIndex === i
                    })
                  } else {
                    newList.forEach((e) => {
                      e.checked = false
                    })
                  }
                  reset({
                    ...getValues(),
                    selects: newList,
                    defaultChecked: [option],
                  })
                }}
              >
                {watch('selects', []).map((e, i) => (
                  <HandleOptioner key={`container-${e.slug}-i`}>
                    <Radio
                      key={e.slug}
                      value={e.slug}
                      sx={{
                        width: '100%',
                        label: { width: '100%' },
                      }}
                      label={
                        <OptionItem
                          item={e}
                          index={i}
                          key={e.slug}
                          getValues={getValues}
                          reset={reset}
                          onColorChange={(item) => {
                            const newList = getValues('selects')
                            newList[i].color = item.color
                            reset({ ...getValues(), selects: newList })
                          }}
                          onTitleChange={(val) => {
                            const newList = getValues('selects')
                            newList[i].title = val
                            reset({ ...getValues(), selects: newList })
                          }}
                        />
                      }
                    />
                    <HandleOption
                      item={e}
                      index={i}
                      getValues={getValues}
                      reset={reset}
                      watch={watch}
                      onDelete={() => {
                        const newList = getValues('selects')
                        newList.splice(i, 1)
                        reset({ ...getValues(), selects: newList })
                      }}
                      onAddItem={() => {
                        const newList = getValues('selects')
                        newList.splice(i + 1, 0, getNewOption(newList))
                        reset({ ...getValues(), selects: newList })
                      }}
                    />
                  </HandleOptioner>
                ))}
              </DragGroup>
            )
          }}
        />
      )}

      {errorTip && <ErrorTip errorMessage={errorTip} />}
      <div className="flex justify-between items-center mt-2">
        <div
          className="flex cursor-pointer"
          onClick={() => {
            const curSelectsList = getValues('selects')
            reset({
              ...getValues(),
              selects: getValues('selects').concat([
                getNewOption(curSelectsList),
              ]),
            })
          }}
        >
          <IconMaps type="collector" width={20} height={20} />
          <span className="ml-2 text-blue-700">添加选项</span>
        </div>
        <SelectsDetail watch={watch}>
          <div className="text-primary-700 cursor-pointer select-none">
            更多设置
          </div>
        </SelectsDetail>
        {/* <div className="flex ml-4 cursor-pointer" onClick={() => {}}>
      <IconMaps type="editor" width={20} height={20} />
      <span className="ml-2 text-blue-700">批量编辑</span>
    </div> */}
      </div>
    </>
  )
}

const Render = function ({
  watch,
  reset,
  register,
  getValues,
  control,
  Controller,
  // errors,
  // ...otherProps
}) {
  return (
    <BasicSettings register={register}>
      <TitleComp title="选项">
        <SelectsComp
          watch={watch}
          reset={reset}
          register={register}
          getValues={getValues}
          control={control}
          Controller={Controller}
        />
      </TitleComp>

      <TitleComp title="选择类型">
        <Controller
          name="multiple"
          control={control}
          render={({ field }) => {
            field.value = toString(field.value)
            return (
              <Radio.Group
                styles={{
                  label: { color: 'var(--ow-color-gray-100)' },
                }}
                size="sm"
                required
                {...field}
                onChange={(value) => {
                  reset({ ...getValues(), multiple: JSON.parse(value) })
                }}
              >
                <Radio value="false" label="单选" />
                <Radio value="true" label="多选" />
              </Radio.Group>
            )
          }}
        />
      </TitleComp>
      <TitleComp title="校验">
        <CheckComp
          register={register}
          registerName="required"
          // defaultValue={getValues('required')}
          label="必填"
        />
      </TitleComp>
      <TitleComp title="选项-其他">
        <CheckComp
          register={register}
          registerName="etc"
          // defaultValue={getValues('etc')}
          label="其他项"
          tipLabel="是否允许用户输入其他内容,比如一个选项叫：其他 。选择其他后，会渲染一个 input框，允许用户自己输入内容"
        />

        {watch('multiple') && (
          <>
            <CheckComp
              register={register}
              registerName="rangeSetting"
              label="限定可选项数"
            />
            {watch('rangeSetting') && (
              <div className="flex  w-full">
                <div className="flex items-center">
                  <div className="mr-2">下限</div>
                  <Controller
                    name="minlen"
                    control={control}
                    render={({ field }) => {
                      return (
                        <NumberInput
                          {...field}
                          styles={{
                            input: { width: '100px' },
                          }}
                          placeholder="下限"
                          min={0}
                          max={watch('maxlen')}
                          required
                        />
                      )
                    }}
                  />
                </div>
                <div className="flex items-center ml-4">
                  <div className="mr-2">上限</div>
                  <Controller
                    name="maxlen"
                    control={control}
                    render={({ field }) => {
                      return (
                        <NumberInput
                          {...field}
                          styles={{
                            input: { width: '100px' },
                          }}
                          placeholder="上限"
                          min={watch('minlen')}
                          max={watch('selects').length}
                          required
                        />
                      )
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </TitleComp>
    </BasicSettings>
  )
}

export default forwardRef(Render)
